var motykaD = require('./../distances/motyka');

module.exports = function motyka(a, b) {
    return 1 - motykaD(a,b);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/similarities/motyka.js
 ** module id = 76
 ** module chunks = 0
 **/